<h1 mat-dialog-title class="text-center">{{data.title}}</h1>

<div mat-dialog-content class="confirm-dialog-content">
    <div *ngIf="data.warning" class="alert alert-warning">{{data.warning}}</div>
    <div class="fs-6">{{data.message}}</div>
</div>

<div mat-dialog-actions class="d-flex justify-content-end">
    <button class="me-2" mat-stroked-button (click)="onCancel()">
        {{data.cancelText || 'Cancel'}}
    </button>
    <button color="primary" mat-raised-button (click)="onConfirm()">
        {{data.confirmText || 'Confirm'}}
    </button>
</div>
